import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const highlightsSlice = createSlice({
  name: 'highlights',
  initialState,
  reducers: {
    highlightsStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        textColor: itemDesign.textColor ?? '#000000',
        opacity: itemDesign.opacity ?? 0,
        size: itemDesign.size ?? 50,
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#000000',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
    },
    highlightsClear: () => initialState,

    highlightsUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    highlightsUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    highlightsUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { highlightsStore, highlightsClear, highlightsUpdateIsLoading, highlightsUpdateIsActive, highlightsUpdateBlockContent } = highlightsSlice.actions;

export const selectHighlightsIsLoading = (state) => state.highlights.isLoading;

export const selectHighlightsId = (state) => state.highlights.id;
export const selectHighlightsUID = (state) => state.highlights.uid;
export const selectHighlightsSID = (state) => state.highlights.sid;

export const selectHighlightsBlockContent = (state) => state.highlights.blockContent;
export const selectHighlightsSortItems = createSelector([selectHighlightsBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectHighlightsItemDesign = (state) => state.highlights.itemDesign;
export const selectHighlightsContainerDesign = (state) => state.highlights.containerDesign;

export default highlightsSlice.reducer;
